module.exports = __webpack_public_path__ + "static/media/tiago.590ad148.jpg";